<script lang="ts" setup>
import { computed, useCssModule } from 'vue';

export interface ContainerProps {
  /** Container width variant */
  width?: 'default' | 'full' | 'narrow' | 'wide';
  /** Element tag to render */
  tag?: string;
}

const props = withDefaults(defineProps<ContainerProps>(), {
  width: 'default',
  tag: 'div',
});

const css = useCssModule('css');

const containerClasses = computed(() => {
  return [css.container, css[`width-${props.width}`]];
});
</script>

<template>
  <component
    :is="props.tag"
    :class="containerClasses"
  >
    <slot />
  </component>
</template>

<style lang="scss" module="css">
$container-pad: clamp(1rem, 2vw, 2rem);
$container-narrow: 65ch; /* Readable for body text */
$container-default: min(90rem, 92vw); /* ~1440px cap */
$container-wide: min(110rem, 96vw); /* ~1760px cap for grids/FAQs */

.container {
  margin-inline: auto;
  padding-inline: $container-pad;
}

.width {
  &-narrow {
    max-width: calc($container-narrow + var(--padding-global));
  }

  &-default {
    max-width: $container-default;
  }

  &-wide {
    max-width: $container-wide;
  }

  &-full {
    max-width: 100vw;
    padding-inline: 0;
  }
}
</style>
